// src/pages/hotelRatings/CreateHotelRating.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditHotelRating from "../../components/hotelRatings/FormAddEditHotelRating";
import { useNavigate } from "react-router-dom";

const CreateHotelRating = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditHotelRating
                isEdit={false}
                onSubmitSuccess={() => navigate("/hotel-ratings")}
            />
        </WrapperSection>
    );
};

export default CreateHotelRating;
